import React from 'react';

import { RefreshSvg } from 'assets/img';
import { Page } from 'components/modules/AutoruLayout/Page/Page';
import { PageContent } from 'components/modules/AutoruLayout/PageContent/PageContent';
import { Button } from 'components/uikit/Button/Button';

import { useErrorPagePresenter } from './ErrorPage.presenter';
import * as S from './ErrorPage.styles';

export const ErrorPage = ({ error }) => {
  const presenter = useErrorPagePresenter({ error });

  return (
    <Page aside={<S.VoidAside />}>
      <PageContent>
        <S.Container>
          <S.ErrorIcon />
          <S.Wrapper>
            <S.Title>{presenter.title}</S.Title>
            <S.Description>{presenter.description}</S.Description>
          </S.Wrapper>
          <Button Icon={RefreshSvg} size="m" theme="3" onClick={presenter.onRefreshButtonClick}>
            Обновить
          </Button>
        </S.Container>
      </PageContent>
    </Page>
  );
};
